import {
  UPDATED_CURRENT_MENU,
  UPDATED_CHECKOUT_PREVIOUS_MENU,
  UPDATE_CLOSE_APPOINTMENT_MODAL_VISIBILITY,
  UPDATE_CANCEL_APPOINTMENT_MODAL_VISIBILITY,
  UPDATE_GO_BACK_FROM_CUSTOMER_PAGE_MODAL_VISIBILITY,
  UPDATE_WHERE_TO_GO_FROM_CUSTOMER_PAGE_MODAL,
  UPDATE_RECURSIVE_APPOINTMENT_CONFIRMATION_MODAL_VISIBILITY,
  UPDATED_GO_BACK_FROM_CHECKOUT,
  UPDATE_GO_BACK_FROM_BOOKING_ONLY_CUSTOMER_PAGE_MODAL_VISIBILITY,
  UPDATE_SEND_CANCELLATION_EMAIL_TOGGLE,
  UPDATE_RESTORE_APPOINTMENT_MODAL_VISIBILITY,
  UPDATE_SEND_RESTORATION_EMAIL_TOGGLE,
  UPDATE_CANCEL_RECURRING_APPOINTMENT_VISIBILITY,
  UPDATE_STORE_CARD_FOR_LATER_MODAL_VISIBILITY,
  UPDATE_MULTISERVICE_APPOINTMENT_CONFIRMATION_MODAL_VISIBILITY,
  UPDATE_CLOSE_WAITLIST_MODAL_VISIBILITY,
  UPDATE_BOOKING_CUSTOMER_PROFILE_MODAL_VISIBILITY,
  UPDATE_ZERO_DOLLAR_MODAL_VISIBILITY
} from "../actions/menu";

import { UPDATED_GLOBAL_ERROR_MESSAGE } from "../actions/globalError";
import { menuInitialState } from "../state/initialState";
import objectAssign from "object-assign";

export default (state = menuInitialState, action) => {
  let newStatus;
  switch (action.type) {
    case UPDATE_SEND_CANCELLATION_EMAIL_TOGGLE:
      newStatus = {
        sendCancellationEmailToggled: action.data
      };
      return objectAssign({}, state, newStatus);
    case UPDATE_SEND_RESTORATION_EMAIL_TOGGLE:
      newStatus = {
        sendRestorationEmailToggled: action.data
      };
      return objectAssign({}, state, newStatus);
    case UPDATE_RECURSIVE_APPOINTMENT_CONFIRMATION_MODAL_VISIBILITY:
      newStatus = {
        recursiveAppointmentConfirmationModalVisible: action.data.isVisible,
        closeAppWhenRecursiveAppointmentModalCloses:
          action.data.closeAppWhenRecursiveAppointmentModalCloses
      };
      return objectAssign({}, state, newStatus);
    case UPDATE_MULTISERVICE_APPOINTMENT_CONFIRMATION_MODAL_VISIBILITY:
      newStatus = {
        multiserviceAppointmentConfirmationModalVisible: action.data.isVisible,
        closeAppWhenMultiserviceModalCloses:
          action.data.closeAppWhenMultiserviceModalCloses
      };
      return objectAssign({}, state, newStatus);
    case UPDATED_GLOBAL_ERROR_MESSAGE:
      newStatus = {
        goBackFromCustomerPageModalVisible: false,
        goBackFromBookingOnlyCustomerPageModalVisible: false,
        recursiveAppointmentConfirmationModalVisible: false,
        closeAppWhenRecursiveAppointmentModalCloses: false,
        closeAppWhenMultiserviceModalCloses: false,
        multiserviceAppointmentConfirmationModalVisible: false
      };
      return objectAssign({}, state, newStatus);
    case UPDATE_GO_BACK_FROM_CUSTOMER_PAGE_MODAL_VISIBILITY:
      newStatus = {
        goBackFromCustomerPageModalVisible: action.data
      };
      return objectAssign({}, state, newStatus);
    case UPDATE_RESTORE_APPOINTMENT_MODAL_VISIBILITY:
      newStatus = {
        restoreAppointmentModalVisible: action.data
      };
      return objectAssign({}, state, newStatus);
    case UPDATE_STORE_CARD_FOR_LATER_MODAL_VISIBILITY:
      newStatus = {
        storeCardForLaterModalVisible: action.data
      };
      return objectAssign({}, state, newStatus);
    case UPDATE_GO_BACK_FROM_BOOKING_ONLY_CUSTOMER_PAGE_MODAL_VISIBILITY:
      newStatus = {
        goBackFromBookingOnlyCustomerPageModalVisible: action.data
      };
      return objectAssign({}, state, newStatus);
    case UPDATE_WHERE_TO_GO_FROM_CUSTOMER_PAGE_MODAL:
      newStatus = {
        locationToGoToFromCustomerPageModal: action.data
      };
      return objectAssign({}, state, newStatus);
    case UPDATE_CLOSE_APPOINTMENT_MODAL_VISIBILITY:
      newStatus = {
        closeAppointmentModalVisible: action.data
      };
      return objectAssign({}, state, newStatus);
    case UPDATE_CANCEL_RECURRING_APPOINTMENT_VISIBILITY:
      newStatus = {
        cancelRecurringAppointmentVisible: action.data
      };
      return objectAssign({}, state, newStatus);
    case UPDATED_CURRENT_MENU:
      newStatus = {
        currentMenu: action.data,
        previousMenu: state.currentMenu
      };
      return objectAssign({}, state, newStatus);
    case UPDATED_CHECKOUT_PREVIOUS_MENU: {
      newStatus = {
        checkoutPreviousMenu: action.data
      };
      return objectAssign({}, state, newStatus);
    }
    case UPDATED_GO_BACK_FROM_CHECKOUT: {
      newStatus = {
        goBackFromCheckout: action.data,
        closeAppointmentModalVisible: action.data
      };
      return objectAssign({}, state, newStatus);
    }
    case UPDATE_CANCEL_APPOINTMENT_MODAL_VISIBILITY:
      newStatus = {
        cancelAppointmentVisible: action.data
      };
      return objectAssign({}, state, newStatus);
    case UPDATE_CLOSE_WAITLIST_MODAL_VISIBILITY:
      newStatus = {
        closeWaitlistModalVisible: action.data
      };
      return objectAssign({}, state, newStatus);
    case UPDATE_BOOKING_CUSTOMER_PROFILE_MODAL_VISIBILITY:
      newStatus = {
        bookingCustomerProfileModalVisible : action.data.isVisible
      }
      return objectAssign({},state,newStatus);
    case UPDATE_ZERO_DOLLAR_MODAL_VISIBILITY:
      newStatus = {
        zeroDollarModalVisible : action.data.isVisible
      }
      return objectAssign({}, state, newStatus);
    default:
      return state;
  }
  return state;
};
